import { createStore, combineReducers, applyMiddleware } from 'redux';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import thunk from 'redux-thunk';
import * as reducers from 'redux/reducers';
import { composeWithDevToolsDevelopmentOnly } from '@redux-devtools/extension';

export const history = createBrowserHistory();

export const store = createStore(
    combineReducers({
        router: connectRouter(history),
        ...reducers
    }),
    composeWithDevToolsDevelopmentOnly(
        applyMiddleware(
            routerMiddleware(history),
            thunk
        )
    )
);
